module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Waarde moet ".concat(args.maxValue, " of eerder zijn.");
  },
  "rangeReversed": "De startdatum moet voor de einddatum liggen.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Waarde moet ".concat(args.minValue, " of later zijn.");
  },
  "unavailableDate": "Geselecteerde datum niet beschikbaar."
};